import { Alert, AlertTitle, Typography } from '@mui/material'

import { Box } from '@/components/ui'
import {
  type IntakeFormRefusal,
  type TemplateIssue,
} from '@/definitions/intakeForm'

const REFUSED_TITLE = 'This definition cannot be used'
const WARNED_TITLE = 'This definition will work, with the following caveats'

const IssueList = ({ issues }: { issues: TemplateIssue[] }) => (
  <Box variant='flexColumn' gap='xs'>
    {issues.map((issue) => (
      <Typography key={issue.code} variant='body2'>
        {issue.message}
      </Typography>
    ))}
  </Box>
)

interface IntakeFormVerdictAlertsProps {
  isAwaitingConfirmation: boolean
  plainRefusalKeepsDefinitionHeading: boolean
  problem: string | null
  refusal: IntakeFormRefusal | null
  warnings: TemplateIssue[]
}

export const IntakeFormVerdictAlerts = ({
  isAwaitingConfirmation,
  plainRefusalKeepsDefinitionHeading,
  problem,
  refusal,
  warnings,
}: IntakeFormVerdictAlertsProps) => (
  <>
    {problem !== null && <Alert severity='error'>{problem}</Alert>}
    {isAwaitingConfirmation ? (
      <Alert severity='warning'>
        <AlertTitle>{WARNED_TITLE}</AlertTitle>
        <IssueList issues={warnings} />
      </Alert>
    ) : (
      refusal !== null && (
        <>
          {refusal.errors !== undefined ? (
            <Alert severity='error'>
              <AlertTitle>{REFUSED_TITLE}</AlertTitle>
              <IssueList issues={refusal.errors} />
            </Alert>
          ) : plainRefusalKeepsDefinitionHeading ? (
            <Alert severity='error'>
              <AlertTitle>{REFUSED_TITLE}</AlertTitle>
              <Typography variant='body2'>{refusal.message}</Typography>
            </Alert>
          ) : (
            <Alert severity='error'>{refusal.message}</Alert>
          )}
          {/* Shown with the refusal: fixing the reasons must not surface the
              caveats as a second refusal. */}
          {warnings.length > 0 && (
            <Alert severity='warning'>
              <AlertTitle>{WARNED_TITLE}</AlertTitle>
              <IssueList issues={warnings} />
            </Alert>
          )}
        </>
      )
    )}
  </>
)
